import MorphingLoader from '@app/src/components/MorphingLoader'
import Avatar, { AvatarSize } from '@app/src/components/Ui/Avatar'
import { palette } from '@app/src/theme/palette'
import { Button, DialogContent, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type EnrichmentSuccessViewProps = {
  onClose: () => void
}

const EnrichmentSuccessView: React.FC<EnrichmentSuccessViewProps> = ({ onClose }) => {
  const { formatMessage } = useIntl()

  return (
    <DialogContent>
      <Stack height="100%" alignItems="center">
        <Stack flexGrow={1} alignItems="center" justifyContent="center" width={588}>
          <Avatar variant="circular" size={AvatarSize.XXXL} sx={{ bgcolor: 'communication.light' }}>
            <MorphingLoader size={56} color={palette.communication.dark} transitionDuration={400} />
          </Avatar>

          <Typography variant="h6" mt={3}>
            {formatMessage({ id: 'form.scheduleEnrichment.success.title' })}
          </Typography>

          <Typography color="textSecondary" mt={2} textAlign="center">
            {formatMessage({ id: 'form.scheduleEnrichment.success.description' })}
          </Typography>

          <Button variant="contained" sx={{ mt: 4 }} onClick={onClose}>
            {formatMessage({ id: 'general.close' })}
          </Button>
        </Stack>
      </Stack>
    </DialogContent>
  )
}

export default EnrichmentSuccessView
